import makeStyles from '@mui/styles/makeStyles'

const useStyles = makeStyles(theme => ({
  root: {
    position: 'relative',
    cursor: 'pointer'
  },

  icon: {
    fontSize: theme.size.xl,
    color: theme.palette.button.text
  },

  count: {
    position: 'absolute',
    top: '0',
    right: '-5px',
    transform: 'translateX(30%) translateY(-30%)'
  }
}))

export default useStyles
